import React, { FC } from 'react';
import ModalConfirm from '../../../../../ModalConfirm';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { SafeHtml } from '@shared/ui';

export interface Props {
	isOpen: boolean;
	onClose: () => void;
	onCancel?: () => void;
	onConfirm?: () => void;
}

const CheckDataModal: FC<Props> = ({ isOpen, onClose, onCancel, onConfirm }) => {
	const { t } = useTranslation('Checkout');
	const { CheckDataModal: theme } = useTheme('Checkout');

	return (
		<ModalConfirm
			isOpen={isOpen}
			onClose={onClose}
			onConfirm={onConfirm}
			onCancel={onCancel}
			title={t('Check the correctness of the entered data')}
			confirmBtn={t('Continue')}
			cancelBtn={t('Check')}
			classes={{ title: theme.checkData__title }}
		>
			<SafeHtml
				tag="div"
				className={theme.contentWrapper}
				html={t('You will not be able to change passenger details after purchasing a ticket.')}
			/>
		</ModalConfirm>
	);
};

export default CheckDataModal;
